
<template>
	<div class="diagnosis-new">
		<v-layout>
			<v-flex xs2>
				<div class="wrapper-big-tools">
					<span
						class="text-tools"
						:style="`color:${$appColors.success}`"
					>HERRAMIENTAS</span>
					<div class="wrapper-tools">
						<tool-drag
							v-for="tool in tools"
							:key="tool.id"
							:item="tool"
							@view="detailTool"
						/>
					</div>
				</div>
			</v-flex>
			<v-flex xs6>
			<v-layout wrap justify-space-around class="mb-70">
					<v-flex xs5
						v-for="(tool, indexTool) in tools"
						:key="tool.id">
						<tool-drop
							:item-selected="indexTool === 0 ? selectedItem : {}"
							:list="listConf"
							@drop="handleDrop"
							@close="closeDrop"
							@configuration="viewConfiguration"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs4>
				<table-tool
					:show-step="false"
					:rotated-card="rotate"
					width="288px"
				>
					<information
						:data="selectTool"
						:title="titleTable"
						v-if="flagInformation"
					/>
					<configuration
						v-if="flagConfiguration"
						:polls-array="polls"
						:active="active"
						:select="selectConfiguration"
						@change-tab="changeTab"
						@value-total="valueTotal"
						@select-poll="selectPoll"
						@validate-value="validateValue"
						@select-areas-employees="selectAreasEmployees"
					/>
					<selecting-employees
						v-if="flagRrHh"
						:area-selected="areaSelected"
						@go-back="showConfigurationComponent"
					/>
					<div
						slot="footer"
						class="w-100"
						v-if="viewButtons">
						<v-layout
							v-if="active === 0"
							justify-space-between
							>
							<v-btn
								type="button"
								small
								class="btn-action"
								color="info"
								@click="closeConfiguration"
							>
								Cerrar
							</v-btn>
							<v-btn
								type="button"
								small
								class="btn-action"
								color="primary"
								:disabled="noSelectedPolls"
								@click="nextTab('next')"
							>
								Siguiente
							</v-btn>
						</v-layout>
						<v-layout v-else justify-space-between>
							<v-flex xs3>
								<v-btn
									type="button"
									class="btn-action w-100"
									color="info"
									@click="nextTab('less')"
								>
									Atrás
								</v-btn>
							</v-flex>
							<v-flex xs3>
								<v-btn
									type="button"
									class="btn-action w-100 btn-disabled-background"
									color="primary"
									@click="endConfiguration"
									:disabled="disabledSave">
									Guardar
								</v-btn>
							</v-flex>
							<v-flex xs3>
								<v-btn
									type="button"
									class="btn-action w-100"
									color="info"
									@click="closeConfiguration"
								>
									Cerrar
								</v-btn>
							</v-flex>
						</v-layout>
					</div>
				</table-tool>
			</v-flex>
		</v-layout>
		<create-dialog
			:dialog="openDialog"
			:footer="false"
			@close-modal="closeDialog"
		>
			<v-layout justify-space-around>
				<v-flex xs5 class="message-error-container">
					<label class="new-survey-label">Nombre de la Encuesta</label>
					<input
						v-model="model.name"
						class="new-diagnosis-input"
						placeholder="Nombre de la Encuesta"
						:style="`color: ${$appColors.info} !important`"
					/>
					<span
						v-if="!model.name"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El nombre es requerido
					</span>
				</v-flex>
				<v-flex xs2 class="message-error-container">
					<label class="new-survey-label">Fecha Inicial</label>
					<app-date-hour
						v-model="model.startDate"
						:allowed-dates="allowedDates"
						@input="allowedDates"
						:style="`border-radius:4px;color: ${$appColors.info} !important`"
					/>
					<span
						v-if="!model.startDate"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						La fecha inicial es requerida
					</span>
				</v-flex>
				<v-flex xs2 class="message-error-container">
					<label class="new-survey-label">Fecha Final</label>
					<app-date-hour
						v-model="model.endDate"
						@input="allowedDates"
						:allowed-dates="(date) => new Date(date) >= new Date()"
						:style="`border-radius:4px;color: ${$appColors.info} !important`"
					/>
					<span
						v-if="!model.endDate"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						La fecha final es requerida
					</span>
				</v-flex>
				<v-flex xs1 pt-4>
					<v-btn
						class="btn btn-action btn-disabled-background"
						color="primary"
						:disabled="!model.name || !model.startDate || !model.endDate"
						@click="finallyDiagnosis">
						Finalizar
					</v-btn>
				</v-flex>
			</v-layout>
		</create-dialog>
		<div class="wrapper-create">
			<v-btn
				color="primary"
				type="button"
				:class="[
					'btn btn-action',
					{ 'animating-btn': notClicked && !disabledCreate },
				]"
				@click="openDiagnoses"
				:disabled="disabledCreate"
			>
				Crear Diagnóstico
			</v-btn>
		</div>
	</div>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop';
import { subDays, subHours, format } from 'date-fns';
import toolDrag from '@/components/diagnosis/tool';
import toolDrop from '@/components/diagnosis/tool-drop';
import tableTool from '@/components/surveys/graphic-factors';
import information from '@/components/diagnosis/information';
import configuration from '@/components/diagnosis/configuration';
import createDialog from '@/components/configuration/open-modal';
import appDateMask from '@/components/app-date-mask';
// import appDate from '@/components/shared/app-date';
import appDateHour from '@/components/shared/app-date-hour';
import selectingEmployees from '@/components/diagnosis/selecting-employees';
import { contains, filter } from 'ramda';

function detailTool({ id, name, description }) {
	this.flagConfiguration = false;
	this.viewButtons = false;
	this.tools = this.tools.map((t) => {
		const newTool = { ...t };
		newTool.select = t.id === id;
		return newTool;
	});
	this.selectTool.name = name;
	this.selectTool.description = description;
	this.titleTable = 'Definición';
	this.rotate = !this.rotate;
}

function handleDrop(item, flag = true) {
	const index = this.tools.findIndex(t => t.id === item.id);
	if (index > -1) {
		this.tools[index].disabled = flag;
	}
}

function closeDrop(item) {
	this.handleDrop(item, false);
	this.flagConfiguration = false;
	this.rotate = true;
	this.selectedItem = {};
	const index = this.tools.findIndex(t => t.id === item.id);
	if (index > -1) {
		this.tools[index].flagConfiguration = false;
		this.tools[index].pollId = null;
		this.tools[index].groups = this.areas.map((a) => {
			const newArea = {
				id: a.id,
				name: a.name,
				selected: false,
				totalEmployees: a.totalEmployees,
				totalFemale: a.totalFemale,
				totalMale: a.totalMale,
				value: 1,
			};
			return newArea;
		});
	}
	this.disabledCreate = !this.tools.some(t => t.flagConfiguration);
}

async function viewConfiguration(item) {
	const index = this.tools.findIndex(t => t.id === item.id);
	const params = {
		toolCode: item.code,
		state: 1,
	};
	try {
		({ data: this.polls } = await this.$http.get('polls', { params }));
		this.selectConfiguration = this.tools[index];
		this.flagConfiguration = true;
		this.flagInformation = false;
		this.flagRrHh = false;
		this.rotate = !this.rotate;
		this.viewButtons = true;
		this.validateValue(this.selectConfiguration);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function changeTab(active) {
	this.active = active;
}

function closeConfiguration() {
	this.flagConfiguration = false;
	this.viewButtons = false;
	this.rotate = !this.rotate;
}

function nextTab(flag) {
	this.active = flag === 'next' ? 1 : 0;
}

function endConfiguration() {
	const msg1 = 'Se realizó la configuración correctamente';
	const msg2 = 'Es momento de CREAR EL DIAGNÓSTICO';
	this.showNotification(msg1);
	setTimeout(() => {
		this.showNotification(msg2, 'primary');
	}, 2500);
	const index = this.tools.findIndex(t => t.id === this.selectConfiguration.id);
	if (index > -1) {
		this.tools[index].flagConfiguration = true;
		this.listConf = [...this.tools];
		this.disabledCreate = false;
	}
}

function created() {
	this.loadData();
}

async function loadData() {
	try {
		({ data: this.areas } = await this.$httpPraktiko.get('groups'));
		this.loadTool();
	} catch (error) {
		this.showGenericError();
	}
}

function openDiagnoses() {
	this.openDialog = true;
	this.notClicked = false;
}

function closeDialog() {
	this.openDialog = false;
}

function valueTotal(value) {
	this.areas = this.areas.map((a) => {
		const newArea = { ...a };
		newArea.value = value;
		return newArea;
	});
}

function selectPoll(value) {
	const index = this.tools.findIndex(t => t.id === this.selectConfiguration.id);
	this.selectConfiguration.pollId = value;
	if (index > -1) {
		this.tools[index].pollId = value;
	}
}

async function loadTool() {
	try {
		const { data: response } = await this.$http.get('tools');
		// filter to show only the top 4 tools
		const desiredIds = [1, 2, 3, 4];
		const toolFilter = filter(obj => contains(obj.id, desiredIds), response);
		this.tools = this.setTools(toolFilter);
		this.selectToolIfExist();
	} catch (error) {
		this.showGenericError();
	}
}

async function selectToolIfExist() {
	const { toolCode, pollId } = this.$route.params;
	if (toolCode || pollId) {
		const tool = this.tools.find(t => t.code === toolCode);
		this.selectedItem = tool;
		this.handleDrop(tool);
		await this.viewConfiguration(tool);
		this.selectPoll(Number(pollId));
	}
}

function setTools(tools) {
	return tools.map((t) => {
		const newRow = { ...t };
		const arrayAreas = this.areas.map((a) => {
			const newArea = {
				id: a.id,
				name: a.name,
				value: 1,
				selected: false,
				employees: a.com_employees,
				totalEmployees: a.com_employees.length,
				totalFemale: a.totalFemale,
				totalMale: a.totalMale,
			};
			return newArea;
		});
		newRow.disabled = false;
		newRow.flagConfiguration = false;
		newRow.image = t.urlImage ? t.urlImage.web : '';
		newRow.pollId = null;
		newRow.groups = [...arrayAreas];
		newRow.selectAll = false;
		return newRow;
	});
}

function validateValue(select) {
	const validateTrue = select.groups.filter(s => s.selected);
	const flag = validateTrue.filter(v => v.value !== '' && v.value > 0);
	this.disabledSave = !flag.length > 0;
}

async function loadDiagnostic(id) {
	try {
		const response = await this.$httpPraktiko.get(`notifications/${id}/diagnostic`);
		this.diagnostic = response.data;
	} catch (error) {
		this.showGenericError();
	}
}

async function finallyDiagnosis() {
	const flagConfiguration = this.tools.filter(t => t.flagConfiguration);
	const arrayTools = flagConfiguration.map((f) => {
		const newTool = {};
		newTool.id = f.id;
		newTool.numApplicants = 0;
		newTool.numGroups = 0;
		newTool.numFemale = 0;
		newTool.numMale = 0;
		const flagGroup = f.groups.filter(g => g.selected);
		newTool.groups = flagGroup.map((g) => {
			const selectedEmployees = this.getSelectedEmployees(g);
			const selectedEmployeesLen = selectedEmployees.ids.length;
			const employeesLen = g.employees.length;
			const employees = selectedEmployeesLen === employeesLen ? [] : selectedEmployees.ids;
			const newGroup = {
				id: g.id,
				value: Number(g.value),
				employees,
			};
			newTool.numApplicants += selectedEmployees.quantity;
			newTool.numFemale += selectedEmployees.female;
			newTool.numMale += selectedEmployees.male;
			return newGroup;
		});
		newTool.numGroups = flagGroup.length;
		newTool.pollId = f.pollId;
		return newTool;
	});
	const formatStarDate = format(subHours(this.model.startDate, 5), 'YYYY-MM-DD HH:mm');
	const formatEndDate = format(subHours(this.model.endDate, 5), 'YYYY-MM-DD HH:mm');
	const body = {
		name: this.model.name,
		startDate: formatStarDate,
		endDate: formatEndDate,
		tools: arrayTools,
	};
	try {
		const response = await this.$httpPraktiko.post('diagnostic', body);
		const id = response.data.id;
		this.showNotification('Se creó correctamente');
		this.loadDiagnostic(id);
		this.goTo('diagnoses');
	} catch (error) {
		this.showGenericError();
	}
}

function getSelectedEmployees(area) {
	return area.employees.reduce((acc, em) => {
		const newAcc = { ...acc };
		if (em.selected) {
			newAcc.ids = acc.ids.concat(em.id);
			newAcc.quantity += 1;
			newAcc.female += Number(em.gender === 2);
			newAcc.male += Number(em.gender === 1);
		}
		return newAcc;
	}, { quantity: 0, female: 0, male: 0, ids: [] });
}

function selectAreasEmployees({ area }) {
	this.flagConfiguration = false;
	this.flagInformation = false;
	this.flagRrHh = true;
	this.viewButtons = false;
	this.areaSelected = area;
	this.rotate = !this.rotate;
	this.changeTab(0);
}

function getAreasEmployees(area) {
	return area.employees.map((e) => {
		const newE = { ...e };
		newE.selected = false;
		return newE;
	});
}

function showConfigurationComponent() {
	this.rotate = !this.rotate;
	this.flagConfiguration = true;
	this.flagInformation = false;
	this.flagRrHh = false;
	this.viewButtons = true;
	setTimeout(() => {
		this.changeTab(1);
	}, 200);
}

function noSelectedPolls() {
	return !this.selectConfiguration.pollId;
}

function handlerRoute() {
	location.reload();
}

function allowedDates(date) {
	const formattedDate = date.toISOString().replace('T', ' ').replace(/\.\d+Z$/, '');
	return new Date(formattedDate) > subDays(new Date(), 1);
}

function data() {
	return {
		diagnostic: [],
		over: false,
		tools: [],
		titleTable: 'Instructivo',
		selectedItem: {},
		selectTool: {
			name: 'Diagnóstico',
			description: `<p>
								Bienvenido a nuestra página para combinar resultados de las diferentes herramientas aplicadas.
							</p>
							<p>
								Elige la herramienta  y configura a quienes enviar. Puedes elegir áreas completas o solo a determinadas personas a través de la "ruedita" de configuración.
							</p>
							<p>
								Si necesitas más información puedes acudir a nuestra web de entrenamiento www.praktiko.tech o escribir un email y solicitar ayuda a info@praktiko.tech
							</p>`,
		},
		rotate: false,
		flagConfiguration: false,
		flagInformation: true,
		flagRrHh: false,
		viewButtons: false,
		polls: [],
		areas: [],
		selectConfiguration: {},
		areaSelected: {},
		active: 0,
		dropSelect: {},
		listConf: [],
		openDialog: false,
		disabledConfiguration: true,
		disabledSave: true,
		disabledCreate: true,
		startDate: null,
		endDate: null,
		model: {
			name: null,
			startDate: null,
			endDate: null,
		},
		notClicked: true,
	};
}

export default {
	components: {
		// appDate,
		appDateHour,
		appDateMask,
		configuration,
		createDialog,
		Drag,
		Drop,
		information,
		tableTool,
		toolDrag,
		toolDrop,
		selectingEmployees,
	},
	computed: {
		noSelectedPolls,
	},
	data,
	created,
	methods: {
		allowedDates,
		closeDrop,
		changeTab,
		closeConfiguration,
		closeDialog,
		detailTool,
		endConfiguration,
		finallyDiagnosis,
		getAreasEmployees,
		getSelectedEmployees,
		handleDrop,
		loadData,
		loadDiagnostic,
		loadTool,
		nextTab,
		openDiagnoses,
		selectAreasEmployees,
		selectPoll,
		setTools,
		showConfigurationComponent,
		selectToolIfExist,
		validateValue,
		valueTotal,
		viewConfiguration,
	},
	watch: {
		'$route.fullPath': handlerRoute,
	},
};
</script>

<style lang="scss" scoped>
	.wrapper-tools {
		background: map-get($colors, white);
		border: solid 1px map-get($colors, gray-slider);
		border-radius: 9px;
		min-height: calc(100vh - 220px);
		padding: 23px 13px;
		width: 103px;
	}

	.text-tools {
		font-family: map-get($fonts, bold);
		font-size: 13px;
		margin-bottom: 10px;
	}

	.wrapper-big-tools {
		align-items: center;
		display: inline-flex;
    flex-direction: column;
	}

	.w-100 {
		width: 100% !important;
	}

	.wrapper-create {
		align-items: center;
		background: map-get($colors, white);
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		padding: 16px 0;
		position: fixed;
		right: 0;
	}

	.w-100 {
		width: 100%;
	}

	.animating-btn {
		animation-name: pulse;
		animation-iteration-count: infinite;
		animation-duration: 1200ms;
	}

	@keyframes pulse {
		0% {
			transform: scale(1, 1);
		}
		20% {
			transform: scale(1.1, 1.05);
		}
		100% {
			transform: scale(1, 1);
		}
	}

	.mb-70 {
		margin-bottom: 70px;
	}

	.new-survey-label {
		color: color(tooltip-gray);
	}

	.message-error-container {
		position: relative;
	}

	.message-error {
		bottom: -15px;
		font-family: font(regular);
		font-size: size(small11);
		position: absolute;
		width: 100%;
	}
	.diagnosis-new {
		@media (max-width: 950px) {
			width: 750px;
		}
	}
</style>




// WEBPACK FOOTER //
// src/pages/diagnosis/page-diagnosis-new-diagnoses.vue